import React, { useCallback, useEffect, useState } from "react";
import styles from "./Table.module.sass";
import RowIndex from "./Row/RowIndex";
import { SCAN_ORDERS_HISTORY } from "../../../../API/Scanner";
import { ConfigProvider, Pagination } from "antd";
import CustomToast from "../../../../components/CustomToast";
import Card from "../../../../components/Card";
import cn from "classnames";
import useDarkMode from "use-dark-mode";

const TableIndex = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [selectedOrders, setSelectedOrders] = useState(new Set());
  const [selectAll, setSelectAll] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(() => {
    const savedPageSize = localStorage.getItem("itemsPerPage");
    return savedPageSize ? parseInt(savedPageSize, 10) : 10;
  });

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const queryParams = [
        { key: "page", value: page },
        { key: "pageSize", value: itemsPerPage },
      ];

      const response = await SCAN_ORDERS_HISTORY(queryParams);
      setData(response.result);
      setTotalItems(response.count);
    } catch (error) {
      CustomToast.fire({
        icon: "error",
        text: "Error fetching data",
      });
    } finally {
      setLoading(false);
    }
  }, [page, itemsPerPage, selectedOrders]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handlePageSizeChange = (current, size) => {
    setItemsPerPage(size);
    setPage(1);
    localStorage.setItem("itemsPerPage", size.toString());
  };

  const darkMode = useDarkMode(false);
  const themeConfig = {
    token: {
      colorPrimary: "#1890ff",
      colorTextBase: darkMode.value ? "#ffffff" : "#000000",
      colorBgContainer: darkMode.value ? "#1f1f1f" : "#ffffff",
      colorBgElevated: darkMode.value ? "#2f2f2f" : "#ffffff",
      colorText: darkMode.value ? "#ffffff" : "#000000",
    },
  };

  return (
    <ConfigProvider theme={themeConfig}>
      <div className={styles.market}>
        <Card className={styles.card}>
          <div className="overflow-auto">
            <div className={styles.table}>
              <div className={styles.row}>
                <div className={cn("whitespace-nowrap", styles.col)}>
                  {" "}
                  Order Number{" "}
                </div>
                <div className={cn("whitespace-nowrap ", styles.col)}>
                  {" "}
                  Time{" "}
                </div>
              </div>
              {data.map((item) => (
                <RowIndex
                  key={item.id}
                  data={item}
                />
              ))}
            </div>
          </div>

          <div className={styles.foot}>
            <Pagination
              current={page}
              total={totalItems}
              pageSize={itemsPerPage}
              onChange={handlePageChange}
              onShowSizeChange={handlePageSizeChange}
              showTotal={(total, range) =>
                `${range[0]}-${range[1]} of ${total} orders`
              }
            />
          </div>
        </Card>
      </div>
    </ConfigProvider>
  );
};

export default TableIndex;
